import { forwardRef } from "react";
function SvgRawExternalLinkIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd" stroke="#000" strokeWidth={2}>
        <path d="M20 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5" />
        <path fill="#000" d="M14 4h6v6z" />
        <path strokeLinejoin="round" d="m19.243 4.757-8.486 8.486" />
      </g>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawExternalLinkIcon);
export default ForwardRef;
